import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  display: grid;
  gap: 16px;

  padding: 20px;

  border-radius: 8px;

  background: #fffae6;
`;

export const ItemContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  > div {
    padding-block-end: 12px;
    border-block-end: 1px solid rgba(0, 0, 0, 0.5);
    &:last-of-type {
      padding-block-end: 0;
      border-block-end: none;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    grid-auto-flow: row;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    > div {
      padding-block-end: 0;
      border-block-end: none;
    }
  }
`;

export const Header = styled.h2`
  color: #000000;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 20px;
  text-transform: uppercase;

  opacity: 0.5;
`;

export const ItemWrapper = styled.div``;
